// Enhancement rules from proven research data
// Ported from enhancement-rules.json

export const enhancementRules = {
  "fire_code_patterns": {
    "standardization_pattern": "\\b(EV|VQ|SM|ZF|FS|WB)(\\d{1,4})(-\\d{2})?\\b",
    "year_context_patterns": [
      {
        "patterns": ["burn from last year", "fire from last year", "last year's", "last year fire"],
        "yearOffset": -1,
        "description": "Fire from previous year"
      },
      {
        "patterns": ["this year", "current year"],
        "yearOffset": 0,
        "description": "Fire from current year"
      }
    ],
    "fire_number_variations": [
      {
        "pattern": "\\bFire\\s+(\\d{1,3})\\b",
        "description": "Generic fire number references"
      },
      {
        "pattern": "\\b(\\d{2,3})\\s*-\\s*(\\d{2})\\b", 
        "description": "Separated fire number and year"
      }
    ],
    "tdo_call_patterns": [
      {
        "pattern": "\\bTDO\\s+Call[^.]*?-\\s*([^-\\n]+)\\s*-[^.]*?(\\w+)\\s+(\\d{1,3}(?:\\s+and\\s+\\d{1,3})*)",
        "description": "TDO call with regional context and fire numbers",
        "regional_mapping": {
          "South Slave": "SM",
          "North Slave": "ZF", 
          "Dehcho": "FS",
          "Deh Cho": "FS",
          "Beaufort Delta": "EV",
          "Sahtu": "VQ",
          "Wood Buffalo": "WB"
        }
      }
    ]
  },
  "common_typos": {
  "TDC call": "TDO Call",
  "TDC Call": "TDO Call", 
  "bar protection": "VAR protection",
  "Ct": "CR",
  "sk patrol": "Smoke Patrol",
  "calle": "called",
  "k patrol": "Smoke Patrol",
  "hoursa": "hours",
  "Lttle Doctor": "Little Doctor",
  "medevac": "medivac",
  "Dehcho": "Deh Cho"
  
  },
  "pricing_detection": {
    "patterns": [
      {
        "pattern": "\\b(\\d+(?:\\.\\d{2})?)\\s+(per\\s+day|per\\s+hour|daily|hourly)\\b",
        "replacement": "$$1 $2",
        "description": "Add currency symbol to pricing"
      },
      {
        "pattern": "\\b(\\d+(?:\\.\\d{2})?)\\s+(quote|cost|price|rate|fee)\\b",
        "replacement": "$$1 $2",
        "description": "Add currency symbol to costs"
      }
    ],
    "finance_indicators": [
      "per day", "per hour", "daily", "hourly", "quote", "cost", "price", "rate", "fee", "budget", "expense"
    ]
  },
  "bd_code_disambiguation": {
    "crew_pattern": "\\bBD([1-9]\\d?)\\b(?!\\d)",
    "aircraft_pattern": "\\bBD(1\\d{2,}|[2-9]\\d{2,})\\b",
    "crew_description": "Beaufort Delta Crew (1-2 digits, no leading zeros)",
    "aircraft_description": "Bird Dog Aircraft (3+ digits with leading zeros)",
    "time_exclusion_contexts": [
      "meters?", "metres?", "km", "kilometers?", "kilometres?", "miles?", "feet", "ft",
      "dollars?", "\\$", "per day", "per hour", "cost", "price", "quote", "rate",
      "hectares?", "ha", "acres?", "kg", "kilograms?", "pounds?", "lbs?",
      "percent", "%", "percentage", "ratio", "count", "number", "amount"
    ]
  },
  "aircraft_callsign_patterns": {
    "three_letter_pattern": "\\b[A-Z]{3}\\b(?!\\s*\\()",
    "context_indicators": [
      "helicopter", "heli", "R/W", "RW", "rw", "rotary wing", "aircraft", "A/C",
      "working", "flying", "landed", "landing", "departed", "inbound", "outbound"
    ],
    "shortening_pattern": "C-G([A-Z]{3})",
    "radio_format": "Helicopter {callsign}",
    "known_aircraft_codes": {
      "DTA": "Helicopter Delta Tango Alpha",
      "WTQ": "Helicopter Whiskey Tango Quebec",
      "DCV": "Helicopter Delta Charlie Victor"
    },
    "helicopter_context_indicators": [
      "rw", "R/W", "rotary wing", "helicopter", "heli", "switch", "swith", "skids up"
    ]
  },
  "crew_identification": {
    "patterns": [
      {
        "pattern": "\\b(SS|NS|DC|BD|Sahtu)\\s*(\\d{1,2})\\b(?!\\d)",
        "format": "{region} Crew {number}",
        "no_leading_zeros": true
      },
      {
        "pattern": "\\b(Dehcho)\\s*(\\d{1,2})\\b",
        "format": "Deh Cho Crew {number}",
        "no_leading_zeros": true
      }
    ]
  },
  "location_context_detection": {
    "movement_patterns": [
      "to {location}", "at {location}", "from {location}", "in {location}",
      "going to {location}", "heading to {location}", "inbound {location}",
      "outbound {location}", "departed {location}"
    ],
    "person_indicators": [
      "called {code}", "{code} called", "spoke with {code}", "{code} said",
      "briefed {code}", "{code} reported", "contacted {code}"
    ]
  },
  "aviation_terminology": {
    "group_patterns": [
      {
        "pattern": "\\bGroup\\s+(\\d+)\\b",
        "replacement": "Tanker Group $1"
      },
      {
        "pattern": "\\b(\\d+)\\s+group\\b",
        "replacement": "Tanker Group $1"
      },
      {
        "pattern": "\\bmachine\\s+([A-Z]{2,3})\\b",
        "replacement": "helicopter $1"
      }
    ],
    "fleet_designations": {
      "802s": "Air Tractor AT802 Fire Boss Tanker Group",
      "215s": "Canadair CL-215 Scooper Tanker Group", 
      "415s": "Canadair CL-415 Super-Scooper Tanker Group"
    }
  },
  "community_recognition": {
    "all_communities": [
      "Yellowknife", "Hay River", "Fort Smith", "Inuvik", "Norman Wells",
      "Fort Simpson", "Fort Resolution", "Enterprise", "Kakisa", "Trout Lake",
      "Jean Marie River", "Wrigley", "Tulita", "Fort Good Hope", "Colville Lake",
      "Deline", "Fort McPherson", "Tsiigehtchic", "Aklavik", "Tuktoyaktuk",
      "Ulukhaktok", "Sachs Harbour", "Paulatuk", "Netla", "Little Doctor"
    ],
    "dehcho_specific": [
      "Fort Simpson", "Enterprise", "Kakisa", "Trout Lake", "Jean Marie River", 
      "Wrigley", "Netla", "Little Doctor"
    ]
  },
  "tagging_rules": {
    "aircraft_indicators": [
      "helicopter", "R/W", "F/W", "aircraft", "A/C", "flying", "landed",
      "departed", "inbound", "outbound", "Group", "tanker", "802s", "215s", "415s"
    ],
    "fire_incident_indicators": [
      "fire", "hot spot", "cold trail", "burn", "smoke", "patrol"
    ],
    "crew_operations_indicators": [
      "crew", "SS\\d{1,2}", "NS\\d{1,2}", "DC\\d{1,2}", "BD\\d{1,2}", "Sahtu\\s*\\d{1,2}"
    ],
    "logistics_indicators": [
      "base", "demob", "roster", "equipment", "fuel", "cache", "staging"
    ],
    "personnel_indicators": [
      "RDO", "TDO", "IC", "duty officer", "called", "briefed"
    ],
    "training_indicators": [
      "training", "practice", "drill", "exercise", "fit test", "fitness", "WFX"
    ],
    "finance_indicators": [
      "per day", "per hour", "daily", "hourly", "quote", "cost", "price", "rate", "fee", "budget", "expense", "\\$", "dollars?"
    ],
    "interjurisdictional_indicators": [
      "Yukon", "Alberta", "BC", "British Columbia", "Saskatchewan", "Manitoba", 
      "Ontario", "Quebec", "Nunavut", "inter-jurisdictional"
    ]
  }
};
